import { useState, useMemo } from "react";
import type { testFilterKey } from "./types.props";

type filterableByTest = { test: string;[key: string]: any };

export const useCardFilters = <T extends filterableByTest>(fullData: T[]) => {
    const [selectedTest, setSelectedTest] = useState<testFilterKey>("all");

    const testOptions = useMemo(() => {
        if (!fullData || fullData.length === 0) return [];

        const uniqueTests = [...new Set(fullData.map((item) => item.test))];

        const options = uniqueTests.map((testName) => ({
            value: testName?.toLocaleLowerCase().replace(/\s+/g, "") || "",
            label: testName || "",
        }));

        return [{ value: "all", label: "Todas las pruebas" }, ...options];
    }, [fullData]);

    const filteredData = useMemo(() => {
        if (selectedTest === "all" || !selectedTest) {
            return fullData;
        }
        const selectedTestName = testOptions.find(
            (opt) => opt.value === selectedTest,
        )?.label;
        return fullData.filter((item) => item.test === selectedTestName);
    }, [fullData, selectedTest, testOptions]);

    const handleTestChange = (key: string) => {
        setSelectedTest(key as testFilterKey);
    };

    return {
        selectedTest,
        testOptions,
        filteredData,
        handleTestChange,
    };
};
